export const GET_GPX_ROUTE = 'GET_GPX_ROUTE';
export const SAVE_GPX_ROUTE = 'SAVE_GPX_ROUTE';
export const DELETE_GPX_ROUTE = 'DELETE_GPX_ROUTE';
export const GET_DISTANCE_CHECK_POINTS = 'GET_DISTANCE_CHECK_POINTS';
export const SAVE_CHECK_POINT_COORDINATES = 'SAVE_CHECK_POINT_COORDINATES';
export const DELETE_CHECK_POINT_COORDINATES = 'DELETE_CHECK_POINT_COORDINATES';
export const VALIDATE_CHECK_POINT_COORDINATES = 'VALIDATE_CHECK_POINT_COORDINATES';
